import { Capacitor } from '@capacitor/core';

// The iOS implementation of @capacitor-firebase/authentication uses a single "savedCall" slot
// internally. If multiple plugin calls overlap (e.g. getCurrentUser() while signInWithGoogle()
// is in-flight), the original call can get overwritten and never resolve/reject -> UI spinner.
//
// Serialize ALL native plugin calls to avoid overlapping calls.
let chain: Promise<unknown> = Promise.resolve();

type NativeAuthCallError = Error & {
  nativeAuthCall?: string;
};

export const runNativeAuthCall = async <T>(label: string, fn: () => Promise<T>): Promise<T> => {
  if (!Capacitor.isNativePlatform()) return fn();

  const next = chain.then(
    () => fn(),
    () => fn()
  );

  // Keep the chain moving regardless of success/failure.
  chain = next.then(
    () => undefined,
    () => undefined
  );

  try {
    return await next;
  } catch (err) {
    // Preserve original stack/shape; add a tiny hint for debugging.
    const errorWithContext = err as NativeAuthCallError;
    errorWithContext.nativeAuthCall = label;
    throw errorWithContext;
  }
};
